import { useState, useEffect } from "react";
import { Loc } from "../App/Loc";

const addMenu = (condition: boolean, item: any) => (condition ? [item] : []);

const useEntityMenuTabs = ({
  entity,
  seriesId,
  isAdminView,
  isFilesView,
  currentUser,
  leagueGameEntity,
}) => {
  const [helpText, setHelpText] = useState("");
  const [isTeamsPage, setIsTeamsPage] = useState(false);
  const [isSeasonPage, setIsSeasonPage] = useState(false);
  const [isEventPage, setIsEventPage] = useState(false);
  const [isStaffPage, setIsStaffPage] = useState(false);
  const [isHuddlePage, setIsHuddlePage] = useState(false);
  const [isMembersPage, setIsMembersPage] = useState(false);
  const [isPhotoPage, setIsPhotoPage] = useState(false);
  const [isDocumentPage, setIsDocumentPage] = useState(false);
  const [isRecordsPage, setIsRecordsPage] = useState(false);
  const [isPlayerPage, setIsPlayerPage] = useState(false);
  const [isGroup, setIsGroup] = useState(false);
  const [isHomePage, setIsHomePage] = useState(false);
  const [isResourses, setisResourses] = useState(false);
  const [isParticipantsPage, setIsParticipantsPage] = useState(false);
  const [isDropDown, setIsDropDown] = useState(false);
  //const [isFeedBackGroup, setIsFeedBackGroup] = useState(false);
  const [isOrganization, setIsOrganization] = useState(false);
  const [isSchoolTeamsPage, setIsSchoolTeamsPage] = useState(false);
  const [isSchoolYearsPage, setIsSchoolYearsPage] = useState(false);
  const [isSchoolAlumniPage, setIsSchoolAlumniPage] = useState(false);
  const [isSchoolGradClassPage, setIsSchoolGradClassPage] = useState(false);
  const [isSchoolAlumniGradClassPage, setIsSchoolAlumniGradClassPage] =
    useState(false);
  const [isSchoolYearOrgPage, setIsSchoolYearOrgPage] = useState(false);
  const [isSchoolYearGradClassPage, setIsSchoolYearGradClassPage] =
    useState(false);
  const [isOccurencePage, setIsOccurencePage] = useState(false);
  const [isFeeCollectionPage, setIsFeeCollectionPage] = useState(false);
  const [isCollectAboutPage, setIsCollectAboutPage] = useState(false);
  const [isCollectMembersPage, setIsCollectMembersPage] = useState(false);
  const [isGameChatPage, setIsGameChatPage] = useState(false);
  const [isGamePostPage, setIsGamePostPage] = useState(false);
  const [isGameTeamsPage, setIsGameTeamsPage] = useState(false);
  const [isLeagueTeamsPage, setIsLeagueTeamsPage] = useState(false);
  const [isLeagueGamesPage, setIsLeagueGamesPage] = useState(false);

  useEffect(() => {
    if (entity?.type === "LeagueGameBase") {
      if (!isAdminView || entity?.status === "Ended") {
        handleGamePostClick();
        return;
      }

      if (isAdminView && entity?.status !== "Started") {
        handleGameChatClick();
        return;
      }

      return;
    }

    // Team Game page
    if (
      leagueGameEntity?.parent?.type === "Game" ||
      leagueGameEntity?.parent?.type === "LeagueSeason"
    ) {
      if (!isAdminView || leagueGameEntity?.status === "Ended") {
        handleGamePostClick();
        return;
      }

      if (leagueGameEntity?.status === "Started") {
        handleGameChatClick();
        return;
      }

      return;
    }
  }, [
    entity?.type,
    entity?.status,
    leagueGameEntity?.parent?.type,
    leagueGameEntity?.status,
    isAdminView,
  ]);

  //#region Tab Menu Click Section
  const resetAllPages = () => {
    setIsTeamsPage(false);
    setIsSeasonPage(false);
    setIsEventPage(false);
    setIsStaffPage(false);
    setIsHuddlePage(false);
    setIsMembersPage(false);
    setIsPhotoPage(false);
    setIsDocumentPage(false);
    setIsRecordsPage(false);
    setIsPlayerPage(false);
    setIsGroup(false);
    setIsHomePage(false);
    setisResourses(false);
    setIsParticipantsPage(false);
    setIsDropDown(false);
    //setIsFeedBackGroup(false);
    setIsOrganization(false);
    setIsSchoolTeamsPage(false);
    setIsSchoolYearsPage(false);
    setIsSchoolAlumniPage(false);
    setIsSchoolGradClassPage(false);
    setIsSchoolAlumniGradClassPage(false);
    setIsSchoolYearOrgPage(false);
    setIsSchoolYearGradClassPage(false);
    setIsOccurencePage(false);
    setIsFeeCollectionPage(false);
    setIsCollectAboutPage(false);
    setIsCollectMembersPage(false);
    setIsGameChatPage(false);
    setIsGamePostPage(false);
    setIsGameTeamsPage(false);
    setIsLeagueTeamsPage(false);
    setIsLeagueGamesPage(false);
  };

  const handleHomeClick = () => {
    resetAllPages();
    setIsTeamsPage(true);
    setIsGamePostPage(
      (entity?.type === "LeagueGameBase" && entity?.status === "Ended") ||
        ((leagueGameEntity?.parent?.type === "Game" ||
          leagueGameEntity?.parent?.type === "LeagueSeason") &&
          leagueGameEntity?.status === "Ended") ||
        !isAdminView,
    );
    handleHelpText();
  };

  const handleSeasonClick = () => {
    resetAllPages();
    setIsSeasonPage(true);
    //handleHelpText();
  };

  const handleEventsClick = () => {
    resetAllPages();
    setIsEventPage(true);
    handleHelpText();
  };

  const handleStaffClick = () => {
    resetAllPages();
    setIsStaffPage(true);
    handleHelpText();
  };

  const handleHuddlesClick = () => {
    resetAllPages();
    setIsHuddlePage(true);
    //handleHelpText();
  };

  const handleMembersClick = () => {
    resetAllPages();
    setIsMembersPage(true);
    handleHelpText();
  };

  const handleAblumClick = () => {
    resetAllPages();
    setIsPhotoPage(true);
    handleHelpText();
  };

  const handleFileClick = () => {
    resetAllPages();
    setIsDocumentPage(true);
    handleHelpText();
  };

  const handleRecordsClick = () => {
    resetAllPages();
    setIsRecordsPage(true);
    //handleHelpText();
  };

  const handleOccurenceClick = () => {
    resetAllPages();
    setIsOccurencePage(true);
    //setSeriesEventsList(entity?.seriesEvents);
    handleHelpText();
  };

  const handlePlayersClick = () => {
    resetAllPages();
    setIsPlayerPage(true);
    handleHelpText();
  };

  const handleGroupClick = () => {
    resetAllPages();
    setIsGroup(true);
    handleHelpText();
  };

  const handleOrganizationClick = () => {
    resetAllPages();
    setIsOrganization(true);
    if (entity?.type === "SchoolYear") {
      setIsSchoolYearOrgPage(true);
    }
    handleHelpText();
  };

  const handleParicipantsClick = () => {
    resetAllPages();
    setIsParticipantsPage(true);
    //handleHelpText();
  };

  const handleResourcesClick = () => {
    resetAllPages();
    setisResourses(true);
    //handleHelpText();
  };

  const handleSchoolTeamsClick = () => {
    resetAllPages();
    setIsSchoolTeamsPage(true);
    handleHelpText();
  };

  const handleSchoolYearsClick = () => {
    resetAllPages();
    setIsSchoolYearsPage(true);
    //handleHelpText();
  };

  const handleSchoolAlumniClick = () => {
    resetAllPages();
    setIsSchoolAlumniPage(true);
    //handleHelpText();
  };

  const handleSchoolGradClassClick = () => {
    resetAllPages();
    setIsSchoolGradClassPage(true);
    //handleHelpText();
  };

  const handleSchoolAlumniGradClassClick = () => {
    resetAllPages();
    setIsSchoolAlumniGradClassPage(true);
    //handleHelpText();
  };

  const handleSchoolYearGradClassClick = () => {
    resetAllPages();
    setIsSchoolYearGradClassPage(true);
    //handleHelpText();
  };

  const handleFeeCollectionClick = () => {
    resetAllPages();
    setIsFeeCollectionPage(true);
  };

  const handleCollectAboutClick = () => {
    resetAllPages();
    setIsCollectAboutPage(true);
  };

  const handleCollectMembersClick = () => {
    resetAllPages();
    setIsCollectMembersPage(true);
  };

  const handleGameChatClick = () => {
    resetAllPages();
    setIsGameChatPage(true);
  };

  const handleGamePostClick = () => {
    resetAllPages();
    setIsGamePostPage(true);
  };

  const handleGameTeamsClick = () => {
    resetAllPages();
    setIsGameTeamsPage(true);
  };

  const handleLeagueTeamsClick = () => {
    resetAllPages();
    setIsLeagueTeamsPage(true);
    handleHelpText();
  };

  const handleLeagueGamesClick = () => {
    resetAllPages();
    setIsLeagueGamesPage(true);
    handleHelpText();
  };

  //#endregion Tab Menu Click Section

  //#region Tab Menu Helptext Section
  const setHelpTextFromMap = (map: Array<[boolean, string]>) => {
    for (const [condition, text] of map) {
      if (condition) {
        setHelpText(text);
        return;
      }
    }
  };

  const handlePersonTapHelpText = () => {
    setHelpTextFromMap([
      [isEventPage, Loc.currentLang.helpText.person.eventTab],
      [isMembersPage, Loc.currentLang.helpText.person.friendTab],
      [isSeasonPage, Loc.currentLang.helpText.person.organizationTab],
      [isPhotoPage, Loc.currentLang.helpText.person.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.person.documentTab],
    ]);
  };

  const handleTeamTapHelpText = () => {
    setHelpTextFromMap([
      [isSeasonPage, Loc.currentLang.helpText.team.seasonTab],
      [isStaffPage, Loc.currentLang.helpText.team.staffTab],
      [isEventPage, Loc.currentLang.helpText.team.eventTab],
      [isGroup, Loc.currentLang.helpText.team.groupTab],
      [isMembersPage, Loc.currentLang.helpText.team.memberTab],
      [isPhotoPage, Loc.currentLang.helpText.team.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.team.documentTab],
    ]);
  };

  const handleLeagueTeamTapHelpText = () => {
    setHelpTextFromMap([
      [isPlayerPage, Loc.currentLang.helpText.season.playersTab],
      [isStaffPage, Loc.currentLang.helpText.season.staffTab],
      [isEventPage, Loc.currentLang.helpText.season.eventTab],
      [isGroup, Loc.currentLang.helpText.season.groupTab],
      [isPhotoPage, Loc.currentLang.helpText.season.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.season.documentTab],
      [isMembersPage, Loc.currentLang.helpText.season.parentTab],
      [isSeasonPage, Loc.currentLang.helpText.season.subTeamTab],
    ]);
  };

  const handleEventTapHelpText = () => {
    setHelpTextFromMap([
      [
        isParticipantsPage && !isResourses,
        Loc.currentLang.helpText.event.participantTab,
      ],
      [
        isResourses && !isParticipantsPage,
        Loc.currentLang.helpText.event.resourcesTab,
      ],
      [isPhotoPage, Loc.currentLang.helpText.event.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.event.documentTab],
    ]);
  };

  const handlePerformanceTapHelpText = () => {
    setHelpTextFromMap([
      [isPlayerPage, Loc.currentLang.helpText.season.playersTab],
      [isStaffPage, Loc.currentLang.helpText.season.staffTab],
      [isEventPage, Loc.currentLang.helpText.season.eventTab],
      [isGroup, Loc.currentLang.helpText.person.organizationTxt],
      [isPhotoPage, Loc.currentLang.helpText.season.photoTabPerformance],
      [isDocumentPage, Loc.currentLang.helpText.season.documentTabPerformance],
      [isMembersPage, Loc.currentLang.helpText.club.memberTab],
      [isSeasonPage, Loc.currentLang.helpText.season.subTeamTab],
    ]);
  };

  const handleClubTapHelpText = () => {
    setHelpTextFromMap([
      [isStaffPage, Loc.currentLang.helpText.club.staffTab],
      [isSeasonPage, Loc.currentLang.helpText.club.termTab],
      [isEventPage, Loc.currentLang.helpText.club.eventTab],
      [isGroup, Loc.currentLang.helpText.club.groupTab],
      [isPhotoPage, Loc.currentLang.helpText.club.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.club.documentTab],
      [isMembersPage, Loc.currentLang.helpText.club.memberTab],
    ]);
  };

  const handleEliteClubTapHelpText = () => {
    setHelpTextFromMap([
      [isStaffPage, Loc.currentLang.helpText.eliteClub.staffTab],
      [isSeasonPage, Loc.currentLang.helpText.eliteClub.organizationTab],
      [isOrganization, Loc.currentLang.helpText.eliteClub.teamsTab],
      [isEventPage, Loc.currentLang.helpText.eliteClub.eventTab],
      [isPhotoPage, Loc.currentLang.helpText.eliteClub.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.eliteClub.documentTab],
      [isMembersPage, Loc.currentLang.helpText.eliteClub.memberTab],
    ]);
  };

  const handleSchoolTapHelpText = () => {
    setHelpTextFromMap([
      [isStaffPage, Loc.currentLang.helpText.school.administrationTab],
      [isMembersPage, Loc.currentLang.helpText.school.staffTab],
      [isEventPage, Loc.currentLang.helpText.school.eventTab],
      [isSeasonPage, Loc.currentLang.helpText.school.organizationTab],
      [isPhotoPage, Loc.currentLang.helpText.school.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.school.documentTab],
      [
        isOrganization,
        isSchoolYearOrgPage
          ? Loc.currentLang.helpText.school.yearOrganizationTab
          : Loc.currentLang.helpText.school.organizationTab,
      ],
    ]);
  };

  const handleGroupTapHelpText = () => {
    setHelpTextFromMap([
      [isStaffPage, Loc.currentLang.helpText.group.staffTab],
      [isMembersPage, Loc.currentLang.helpText.group.memberTab],
      [isEventPage, Loc.currentLang.helpText.group.eventTab],
      [isSeasonPage, Loc.currentLang.helpText.group.organizationTab],
      [isPhotoPage, Loc.currentLang.helpText.group.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.group.documentTab],
      [isGroup, Loc.currentLang.helpText.group.groupTab],
    ]);
  };

  const handleClassTapHelpText = () => {
    setHelpTextFromMap([
      [isStaffPage, Loc.currentLang.helpText.class.staffTab],
      [isPlayerPage, Loc.currentLang.helpText.class.studentTab],
      [isEventPage, Loc.currentLang.helpText.class.eventTab],
      [isGroup, Loc.currentLang.helpText.group.groupTab],
      [isPhotoPage, Loc.currentLang.helpText.class.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.class.documentTab],
      [isMembersPage, Loc.currentLang.helpText.class.parentTab],
    ]);
  };

  const handleGradClassTapHelpText = () => {
    setHelpTextFromMap([
      [isStaffPage, Loc.currentLang.helpText.gradClass.staffTab],
      [isMembersPage, Loc.currentLang.helpText.class.parentTab],
      [isEventPage, Loc.currentLang.helpText.gradClass.eventTab],
      [isGroup, Loc.currentLang.helpText.gradClass.groupTab],
      [isPlayerPage, Loc.currentLang.helpText.class.studentTab],
      [isPhotoPage, Loc.currentLang.helpText.gradClass.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.gradClass.documentTab],
    ]);
  };

  const handleCommunityTapHelpText = () => {
    setHelpTextFromMap([
      [isStaffPage, Loc.currentLang.helpText.community.staffTab],
      [isMembersPage, Loc.currentLang.helpText.community.memberTab],
      [isEventPage, Loc.currentLang.helpText.community.eventTab],
      [isSeasonPage, Loc.currentLang.helpText.community.organizationTab],
      [isOrganization, Loc.currentLang.helpText.community.organizationTab],
      [isPhotoPage, Loc.currentLang.helpText.community.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.community.documentTab],
    ]);
  };

  const handleNeighborhoodTapHelpText = () => {
    setHelpTextFromMap([
      [isStaffPage, Loc.currentLang.helpText.neighborHood.administrationTab],
      [isMembersPage, Loc.currentLang.helpText.neighborHood.neighborTab],
      [isEventPage, Loc.currentLang.helpText.neighborHood.eventTab],
      [isOrganization, Loc.currentLang.helpText.neighborHood.organizationTab],
      [isPhotoPage, Loc.currentLang.helpText.neighborHood.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.neighborHood.documentTab],
    ]);
  };

  const handleOrganizationTapHelpText = () => {
    setHelpTextFromMap([
      [isStaffPage, Loc.currentLang.helpText.organization.staffTab],
      [isMembersPage, Loc.currentLang.helpText.organization.memberTab],
      [isEventPage, Loc.currentLang.helpText.organization.eventTab],
      [isOrganization, Loc.currentLang.helpText.organization.organizationTab],
      [isPhotoPage, Loc.currentLang.helpText.organization.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.organization.documentTab],
    ]);
  };

  const handleTermTapHelpText = () => {
    setHelpTextFromMap([
      [isPlayerPage, Loc.currentLang.helpText.term.memberTab],
      [isStaffPage, Loc.currentLang.helpText.term.directorTab],
      [isEventPage, Loc.currentLang.helpText.term.eventTab],
      [isGroup, Loc.currentLang.helpText.term.groupTab],
      [isPhotoPage, Loc.currentLang.helpText.term.photoTab],
      [isDocumentPage, Loc.currentLang.helpText.term.documentTab],
      [isMembersPage, Loc.currentLang.helpText.term.parentTab],
    ]);
  };

  const handleHelpText = () => {
    switch (entity?.type) {
      case "Person":
        handlePersonTapHelpText();
        break;
      case "Team":
      case "LeagueGameBase":
        if (entity?.subType === "Club") {
          handleClubTapHelpText();
        } else {
          handleTeamTapHelpText();
        }
        break;
      case "PlayerOrg":
        if (entity?.subType === "Term") {
          handleTermTapHelpText();
        } else if (entity?.subType === "Class") {
          handleClassTapHelpText();
        } else if (entity?.subType === "MusicGroup") {
          handlePerformanceTapHelpText();
        } else if (entity?.subType === "GradClass") {
          handleGradClassTapHelpText();
        } else {
          handleLeagueTeamTapHelpText();
        }
        break;
      case "Event":
        handleEventTapHelpText();
        break;
      case "Club":
        handleEliteClubTapHelpText();
        break;
      case "School":
      case "SchoolYear":
        if (
          entity?.type === "SchoolYear" &&
          (isPlayerPage || isPhotoPage || isDocumentPage)
        ) {
          handleGradClassTapHelpText();
        } else {
          handleSchoolTapHelpText();
        }
        break;
      case "Group":
        handleGroupTapHelpText();
        break;
      case "Community":
        handleCommunityTapHelpText();
        break;
      case "Neighborhood":
        handleNeighborhoodTapHelpText();
        break;
      case "Organization":
        handleOrganizationTapHelpText();
        break;
      default:
        setHelpText(Loc.currentLang.helpText.Team);
        break;
    }
  };
  //#endregion Tab Menu Helptext Section

  //#region Tab Menu Section
  const hasEvents = entity?.ownedEvents?.length > 0 || isAdminView;
  const hasPlayers = entity?.players?.length > 0 || isAdminView;
  const hasMembers = entity?.members?.length > 0 || isAdminView;
  const hasStaff = entity?.staff?.length > 0 || isAdminView;
  const hasRecords =
    entity?.albums?.filter((x) => x.subType === "Livestream")?.length > 0;
  const hasAlbums =
    entity?.albums?.filter((x) => x.subType !== "Livestream")?.length > 0 ||
    isAdminView;
  const hasFiles = isFilesView || isAdminView;

  const hasCollects =
    isAdminView || entity?.childOrgs?.some((x) => x?.type === "Collect");

  const hasHuddles =
    isAdminView ||
    (currentUser?.orgs?.some(
      (org) =>
        org.type === "Channel" &&
        entity?.childOrgs?.some(
          (child) => child.type === "Channel" && child.id === org.id,
        ),
    ) ??
      false);

  const hasGroupOrganizations =
    isAdminView || entity?.childOrgs?.some((x) => x?.type === "Group");

  const commonMenus = [
    ...addMenu(hasRecords, {
      id: "records",
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: "albums",
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: "files",
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasHuddles, {
      id: "huddles",
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //TeamsMenu
  const hasTeamSeasons =
    isAdminView ||
    entity?.childOrgs?.some(
      (x) =>
        x?.type !== "Group" && x?.type !== "Channel" && x?.type !== "Collect",
    );

  const hasTeamGroups =
    isAdminView || entity?.childOrgs?.some((x) => x?.type === "Group");

  const TeamsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasTeamSeasons, {
      id: 3,
      name: Loc.currentLang.menu.seasons,
      flag: isSeasonPage,
      fn: handleSeasonClick,
    }),
    ...addMenu(hasTeamGroups, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isGroup,
      fn: handleGroupClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...commonMenus,
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasMembers, {
      id: 10,
      name: Loc.currentLang.menu.members,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
  ];

  //SeasonsMenu
  const hasSeasonOrganizations =
    isAdminView ||
    entity?.childOrgs?.some(
      (x) =>
        x?.type !== "Group" && x?.type !== "Channel" && x?.type !== "Collect",
    );

  const SeasonsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasPlayers, {
      id: 3,
      name: Loc.currentLang.menu.players,
      flag: isPlayerPage,
      fn: handlePlayersClick,
    }),
    ...addMenu(hasSeasonOrganizations, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isSeasonPage,
      fn: handleSeasonClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...commonMenus,
    ...addMenu(hasMembers, {
      id: 9,
      name: Loc.currentLang.menu.parents,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasStaff, {
      id: 10,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
  ];

  //LeagueOwnerMenu
  const hasLeagueSeasons =
    isAdminView || entity?.childOrgs?.some((x) => x?.type === "LeagueSeason");

  const LeagueOwnerMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasLeagueSeasons, {
      id: 3,
      name: Loc.currentLang.menu.seasons,
      flag: isSeasonPage,
      fn: handleSeasonClick,
    }),
    ...addMenu(hasCollects, {
      id: 4,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 5,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 6,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 7,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 8,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasMembers, {
      id: 9,
      name: Loc.currentLang.menu.members,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasHuddles, {
      id: 10,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //LeagueSeasonMenu
  const LeagueSeasonMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    {
      id: 3,
      name: Loc.currentLang.menu.teams,
      flag: isLeagueTeamsPage,
      fn: handleLeagueTeamsClick,
    },
    {
      id: 4,
      name: Loc.currentLang.menu.games,
      flag: isLeagueGamesPage,
      fn: handleLeagueGamesClick,
    },
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasMembers, {
      id: 10,
      name: Loc.currentLang.menu.members,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasHuddles, {
      id: 11,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //PerformanceGroupMenu
  const PerformanceGroupMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasPlayers, {
      id: 3,
      name: Loc.currentLang.menu.players,
      flag: isPlayerPage,
      fn: handlePlayersClick,
    }),
    ...addMenu(hasGroupOrganizations, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isGroup,
      fn: handleGroupClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasMembers, {
      id: 9,
      name: Loc.currentLang.menu.members,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasStaff, {
      id: 10,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasHuddles, {
      id: 11,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //TermsMenu
  const TermsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasPlayers, {
      id: 3,
      name: Loc.currentLang.menu.members,
      flag: isPlayerPage,
      fn: handlePlayersClick,
    }),
    ...addMenu(hasGroupOrganizations, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isGroup,
      fn: handleGroupClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.directors,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasMembers, {
      id: 10,
      name: Loc.currentLang.menu.parents,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasHuddles, {
      id: 11,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //TeamClubMenu
  const hasTerms =
    isAdminView ||
    entity?.childOrgs?.some(
      (x) => x?.type === "PlayerOrg" && x?.subType === "Term",
    );

  const hasClubOrganizations =
    isAdminView ||
    entity?.childOrgs?.some(
      (x) =>
        x?.type !== "PlayerOrg" &&
        x?.subType !== "Term" &&
        x?.type !== "Channel" &&
        x?.type !== "Collect",
    );

  const TeamClubMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasTerms, {
      id: 3,
      name: Loc.currentLang.menu.terms,
      flag: isSeasonPage,
      fn: handleSeasonClick,
    }),
    ...addMenu(hasClubOrganizations, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isGroup,
      fn: handleGroupClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasMembers, {
      id: 10,
      name: Loc.currentLang.menu.members,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasHuddles, {
      id: 11,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //EliteClubMenu
  const hasEliteTeams =
    isAdminView ||
    entity?.childOrgs?.some(
      (x) => x?.type !== "Channel" && x?.type !== "Collect",
    );

  const EliteClubMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasEliteTeams, {
      id: 3,
      name: Loc.currentLang.menu.teams,
      flag: isOrganization,
      fn: handleOrganizationClick,
    }),
    ...addMenu(hasCollects, {
      id: 4,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 5,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 6,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 7,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 8,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasMembers, {
      id: 9,
      name: Loc.currentLang.menu.members,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasHuddles, {
      id: 10,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //SchoolMenu
  const SchoolMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },

    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    {
      id: 3,
      name: Loc.currentLang.menu.teams,
      flag: isSchoolTeamsPage,
      fn: handleSchoolTeamsClick,
    },
    {
      id: 4,
      name: Loc.currentLang.menu.years,
      flag: isSchoolYearsPage,
      fn: handleSchoolYearsClick,
    },
    {
      id: 5,
      name: Loc.currentLang.menu.alumni,
      flag: isSchoolAlumniPage,
      fn: handleSchoolAlumniClick,
    },
    {
      id: 6,
      name: Loc.currentLang.menu.gradClass,
      flag: isSchoolGradClassPage,
      fn: handleSchoolGradClassClick,
    },
    ...addMenu(hasCollects, {
      id: 7,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 8,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 9,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 10,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasMembers, {
      id: 11,
      name: Loc.currentLang.menu.staff,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasStaff, {
      id: 12,
      name: Loc.currentLang.menu.administration,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasHuddles, {
      id: 13,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //SchoolAlumniMenu
  const hasAlumniGradClass =
    isAdminView || entity?.childOrgs?.some((x) => x?.type === "PlayerOrg");

  const SchoolAlumniMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasAlumniGradClass, {
      id: 2,
      name: Loc.currentLang.menu.gradClass,
      flag: isSchoolAlumniGradClassPage,
      fn: handleSchoolAlumniGradClassClick,
    }),
    ...addMenu(hasStaff, {
      id: 3,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasRecords, {
      id: 4,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 5,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 6,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
  ];

  //SchoolYearMenu
  const hasSchoolYearOrganizations =
    isAdminView ||
    entity?.childOrgs?.some(
      (x) => x?.type !== "Channel" && x?.type !== "Collect",
    );

  const SchoolYearMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasSchoolYearOrganizations, {
      id: 3,
      name: Loc.currentLang.menu.organization,
      flag: isOrganization,
      fn: handleOrganizationClick,
    }),
    {
      id: 4,
      name: Loc.currentLang.menu.gradClass,
      flag: isSchoolYearGradClassPage,
      fn: handleSchoolYearGradClassClick,
    },
    {
      id: 5,
      name: Loc.currentLang.menu.students,
      flag: isPlayerPage,
      fn: handlePlayersClick,
    },
    ...addMenu(hasMembers, {
      id: 6,
      name: Loc.currentLang.menu.parents,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasCollects, {
      id: 7,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 8,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 9,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 10,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
  ];

  //SchoolGradClassMenu
  const SchoolGradClassMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasPlayers, {
      id: 2,
      name: Loc.currentLang.menu.students,
      flag: isPlayerPage,
      fn: handlePlayersClick,
    }),
    ...addMenu(hasMembers, {
      id: 3,
      name: Loc.currentLang.menu.parents,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasStaff, {
      id: 4,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
  ];

  //GradClassMenu
  const hasGradClassGroups =
    isAdminView || entity?.childOrgs?.some((x) => x?.type === "Group");

  const GradClassMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasPlayers, {
      id: 3,
      name: Loc.currentLang.menu.students,
      flag: isPlayerPage,
      fn: handlePlayersClick,
    }),
    ...addMenu(hasGradClassGroups, {
      id: 4,
      name:
        entity?.subType === "GradClass"
          ? Loc.currentLang.menu.organizations
          : Loc.currentLang.menu.organization,
      flag: isGroup,
      fn: handleGroupClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasMembers, {
      id: 10,
      name: Loc.currentLang.menu.parents,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasHuddles, {
      id: 11,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //ClassMenu
  const hasClassGroups =
    isAdminView || entity?.childOrgs?.some((x) => x?.type === "Group");

  const ClassMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasPlayers, {
      id: 3,
      name: Loc.currentLang.menu.students,
      flag: isPlayerPage,
      fn: handlePlayersClick,
    }),
    ...addMenu(hasClassGroups, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isGroup,
      fn: handleGroupClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasMembers, {
      id: 10,
      name: Loc.currentLang.menu.parents,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasHuddles, {
      id: 11,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //GroupMenu
  const GroupMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasMembers, {
      id: 3,
      name: Loc.currentLang.menu.members,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasGroupOrganizations, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isGroup,
      fn: handleGroupClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasHuddles, {
      id: 10,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //OrgsMenu
  const hasOrganizations =
    isAdminView ||
    entity?.childOrgs?.some(
      (x) => x?.type !== "Channel" && x?.type !== "Collect",
    );

  const OrgsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasMembers, {
      id: 3,
      name: Loc.currentLang.menu.employees,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasOrganizations, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isOrganization,
      fn: handleOrganizationClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasHuddles, {
      id: 10,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //NeighborhoodMenu
  const NeighborhoodMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasMembers, {
      id: 3,
      name: Loc.currentLang.menu.neighbors,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasOrganizations, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isOrganization,
      fn: handleOrganizationClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasHuddles, {
      id: 10,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //CommunityMenu
  const CommunityMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    ...addMenu(hasEvents, {
      id: 2,
      name: Loc.currentLang.menu.events,
      flag: isEventPage,
      fn: handleEventsClick,
    }),
    ...addMenu(hasMembers, {
      id: 3,
      name: Loc.currentLang.menu.members,
      flag: isMembersPage,
      fn: handleMembersClick,
    }),
    ...addMenu(hasOrganizations, {
      id: 4,
      name: Loc.currentLang.menu.organization,
      flag: isOrganization,
      fn: handleOrganizationClick,
    }),
    ...addMenu(hasCollects, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(hasRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(hasAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(hasFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
    ...addMenu(hasStaff, {
      id: 9,
      name: Loc.currentLang.menu.staff,
      flag: isStaffPage,
      fn: handleStaffClick,
    }),
    ...addMenu(hasHuddles, {
      id: 10,
      name: Loc.currentLang.menu.huddless,
      flag: isHuddlePage,
      fn: handleHuddlesClick,
    }),
  ];

  //CollectMenu
  const CollectMenu = [
    ...addMenu(!!entity?.profile?.text, {
      id: 1,
      name: Loc.currentLang.feeCollect.about,
      flag: isCollectAboutPage,
      fn: handleCollectAboutClick,
    }),
    ...addMenu(isAdminView, {
      id: 2,
      name: Loc.currentLang.menu.members,
      flag: isCollectMembersPage,
      fn: handleCollectMembersClick,
    }),
  ];

  //GameMenu
  const GameMenu = [
    ...(isAdminView &&
    ((entity?.type === "LeagueGameBase" && entity?.status !== "Ended") ||
      ((leagueGameEntity?.parent?.type === "Game" ||
        leagueGameEntity?.parent?.type === "LeagueSeason") &&
        leagueGameEntity?.status !== "Ended"))
      ? [
          {
            id: 1,
            name: Loc.currentLang.gameEvent.chat,
            flag: isGameChatPage,
            fn: handleGameChatClick,
          },
        ]
      : []),
    {
      id: 2,
      name: Loc.currentLang.gameEvent.post,
      flag: isGamePostPage,
      fn: handleGamePostClick,
    },
    ...(entity?.type === "LeagueGameBase"
      ? [
          ...addMenu(true, {
            id: 3,
            name: Loc.currentLang.menu.teams,
            flag: isGameTeamsPage,
            fn: handleGameTeamsClick,
          }),
          ...addMenu(hasStaff, {
            id: 4,
            name: Loc.currentLang.menu.staff,
            flag: isStaffPage,
            fn: handleStaffClick,
          }),
        ]
      : []),
    ...addMenu(hasRecords, {
      id: entity?.type === "LeagueGameBase" ? 5 : 3,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
  ];

  //EventsMenu
  const curSeriesEvent = entity?.seriesEvents?.find((x) => x.id === seriesId);
  const isSeriesActive = curSeriesEvent?.status !== "Canceled";
  const isTeamActive = curSeriesEvent?.status !== "Canceled";

  const showFeeCollecion =
    (isAdminView && isTeamActive && isSeriesActive) ||
    entity?.childOrgs?.some((x) => x?.type === "Collect");

  const currentEvt =
    currentUser?.events?.find((x) => x?.id === entity?.id) ?? {};
  const eventsLength = currentEvt?.events?.length ?? 0;
  const seriesLength = entity?.seriesEvents?.length ?? 0;
  const showOccurence =
    (entity?.eventType === "Meeting" || entity?.eventType === "Practice") &&
    (eventsLength > 1 ||
      (eventsLength !== 0 && eventsLength === seriesLength) ||
      isAdminView);

  let showResources = isAdminView || false;
  let showRecords = isAdminView || false;
  let showAlbums = isAdminView || false;
  let showFiles = isAdminView || false;

  if (entity?.participants?.some((x) => x?.id === currentUser?.id)) {
    showResources =
      (entity?.resources?.length > 0 ||
        curSeriesEvent?.resources?.length > 0 ||
        isAdminView) &&
      isTeamActive &&
      isSeriesActive;

    showRecords =
      entity?.albums?.filter((x) => x.subType === "Livestream")?.length > 0 &&
      isTeamActive &&
      isSeriesActive;

    showAlbums =
      (entity?.albums?.filter((x) => x.subType !== "Livestream")?.length > 0 ||
        isAdminView) &&
      isTeamActive &&
      isSeriesActive;

    showFiles =
      (entity?.files?.length > 0 || isAdminView) &&
      isTeamActive &&
      isSeriesActive;
  }

  const EventsMenu = [
    {
      id: 1,
      name: Loc.currentLang.menu.home,
      flag: isTeamsPage,
      fn: handleHomeClick,
    },
    {
      id: 2,
      name: Loc.currentLang.menu.participants,
      flag: isParticipantsPage,
      fn: handleParicipantsClick,
    },
    ...addMenu(showResources, {
      id: 3,
      name: Loc.currentLang.menu.resources,
      flag: isResourses,
      fn: handleResourcesClick,
    }),
    ...addMenu(showOccurence, {
      id: 4,
      name: Loc.currentLang.menu.occurrence,
      flag: isOccurencePage,
      fn: handleOccurenceClick,
    }),
    ...addMenu(showFeeCollecion, {
      id: 5,
      name: Loc.currentLang.feeCollect.feeCollection,
      flag: isFeeCollectionPage,
      fn: handleFeeCollectionClick,
    }),
    ...addMenu(showRecords, {
      id: 6,
      name: Loc.currentLang.menu.records,
      flag: isRecordsPage,
      fn: handleRecordsClick,
    }),
    ...addMenu(showAlbums, {
      id: 7,
      name: Loc.currentLang.menu.albums,
      flag: isPhotoPage,
      fn: handleAblumClick,
    }),
    ...addMenu(showFiles, {
      id: 8,
      name: Loc.currentLang.menu.files,
      flag: isDocumentPage,
      fn: handleFileClick,
    }),
  ];

  const getMenu = () => {
    if (entity?.type === "Collect") return CollectMenu;

    if (
      entity?.type === "LeagueGameBase" ||
      (entity?.type === "Game" && leagueGameEntity?.status === "Started")
    ) {
      return GameMenu;
    }

    if (entity?.type === "LeagueOwner") {
      return LeagueOwnerMenu;
    }

    if (entity?.type === "LeagueSeason") {
      return LeagueSeasonMenu;
    }

    if (entity?.subType === "Club") {
      return TeamClubMenu;
    }

    if (entity?.type === "Club") {
      return EliteClubMenu;
    }

    if (entity?.subType === "Class") {
      return ClassMenu;
    }

    if (
      (entity?.parent?.type === "School" ||
        entity?.parent?.subType === "Alumni") &&
      entity?.subType === "GradClass"
    ) {
      return SchoolGradClassMenu;
    }

    if (entity?.subType === "GradClass") {
      return GradClassMenu;
    }

    if (entity?.type === "Neighborhood") {
      return NeighborhoodMenu;
    }

    if (entity?.type === "Community") {
      return CommunityMenu;
    }

    if (entity?.type === "School") {
      return SchoolMenu;
    }

    if (entity?.type === "SchoolYear") {
      return SchoolYearMenu;
    }

    if (entity?.type === "Team") {
      return TeamsMenu;
    }

    if (
      entity?.type === "PlayerOrg" &&
      entity?.subType !== "Term" &&
      entity?.subType !== "MusicGroup"
    ) {
      return SeasonsMenu;
    }

    if (entity?.type === "PlayerOrg" && entity?.subType === "Term") {
      return TermsMenu;
    }

    if (entity?.type === "Event" || entity?.type === "Game") {
      return EventsMenu;
    }

    if (entity?.type === "PlayerOrg" && entity?.subType === "MusicGroup") {
      return PerformanceGroupMenu;
    }

    if (entity?.type === "Group" && entity?.subType === "Alumni") {
      return SchoolAlumniMenu;
    }

    if (entity?.type === "Group") {
      return GroupMenu;
    }

    return OrgsMenu;
  };

  const menuTabs = getMenu();
  //#endregion Tab Menu Section

  return {
    // menu
    menuTabs,

    // help text
    helpText,
    //setHelpText,

    // page states
    isTeamsPage,
    isSeasonPage,
    isEventPage,
    isStaffPage,
    isHuddlePage,
    isMembersPage,
    isPhotoPage,
    isDocumentPage,
    isRecordsPage,
    isPlayerPage,
    isGroup,
    isHomePage,
    isResourses,
    isParticipantsPage,
    isDropDown,
    //isFeedBackGroup,
    isOrganization,
    isSchoolTeamsPage,
    isSchoolYearsPage,
    isSchoolAlumniPage,
    isSchoolGradClassPage,
    isSchoolAlumniGradClassPage,
    isSchoolYearOrgPage,
    isSchoolYearGradClassPage,
    isOccurencePage,
    isFeeCollectionPage,
    isCollectAboutPage,
    isCollectMembersPage,
    isGameChatPage,
    isGamePostPage,
    isGameTeamsPage,
    isLeagueTeamsPage,
    isLeagueGamesPage,

    // setters
    setIsTeamsPage,
    //setIsSeasonPage,
    //setIsEventPage,
    //setIsStaffPage,
    //setIsHuddlePage,
    //setIsMembersPage,
    //setIsPhotoPage,
    //setIsDocumentPage,
    //setIsRecordsPage,
    //setIsPlayerPage,
    //setIsGroup,
    setIsHomePage,
    //setisResourses,
    //setIsParticipantsPage,
    setIsDropDown,
    ////setIsFeedBackGroup,
    setIsOrganization,
    //setIsSchoolTeamsPage,
    //setIsSchoolYearsPage,
    //setIsSchoolAlumniPage,
    //setIsSchoolGradClassPage,
    //setIsSchoolAlumniGradClassPage,
    //setIsSchoolYearOrgPage,
    //setIsSchoolYearGradClassPage,
    //setIsOccurencePage,
    //setIsFeeCollectionPage,
    setIsCollectAboutPage,
    setIsCollectMembersPage,
    setIsGameChatPage,
    //setIsGamePostPage,
    //setIsGameTeamsPage.
    //setIsLeagueTeamsPage,
    //setIsLeagueGamesPage,

    // helpers
    resetAllPages,
    handleCollectMembersClick,
    handleGameChatClick,
    handleHomeClick,
    handleHelpText,
    //handleHelpText,
  };
};

export default useEntityMenuTabs;
